const ASSETS = ['eth']

export function getAssetIndex(asset: string | undefined) {
  return ASSETS.indexOf(asset || 'eth')
}

export function getAssetName(assetIndex: number) {
  return ASSETS[assetIndex]
}
